// extracted by mini-css-extract-plugin
export default {"box":"bulkSpareLotListPage_box__gkhir"};